
import $ from 'jquery';


// https://stackoverflow.com/questions/7838680/detecting-that-the-browser-has-no-mouse-and-is-touch-only
$(document).ready(function () {
  var $body = $('body');
  var $html = $('html');
  var detectEvents = function (e) {
    if (e.type === 'mousemove') {
      $html.addClass('has-mousemove');
    } else if (e.type === 'touchstart') {
      $html.addClass('has-touchstart');
    }
    $body.off('.detectEventType');
  }
  // attach both events to body
  $body.on('mousemove.detectEventType touchstart.detectEventType', detectEvents);
});


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/has-mouse-event.js